import React from 'react';
import { createLogger } from '../utils/logger';

const log = createLogger('crash');

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, info: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        log.error('Приложение упало', {
            message: error?.message,
            stack: error?.stack?.slice(0, 400),
            componentStack: info?.componentStack?.slice(0, 400),
        });
        // Auto-reload on NaN/LatLng errors instead of showing error screen
        if (error && error.message && (error.message.includes('NaN') || error.message.includes('null') || error.message.includes('lat'))) {
            // Prevent infinite reload — max 3 attempts
            const attempts = parseInt(sessionStorage.getItem('error_reload_count') || '0');
            if (attempts >= 3) { sessionStorage.removeItem('error_reload_count'); this.setState({ info }); return; }
            sessionStorage.setItem('error_reload_count', String(attempts + 1));
            log.warn('Ошибка координат — перезагружаем экран', { attempt: attempts + 1 });
            setTimeout(() => {
                try { window.location.reload(); } catch(e) { window.location.href = window.location.href; }
            }, 500);
            return;
        }
        this.setState({ info });
        const splash = document.getElementById('splash');
        if (splash) splash.style.display = 'none';
        // Сохраняем ошибку для диагностики
        try {
            localStorage.setItem('last_error', JSON.stringify({
                msg: error?.message,
                stack: error?.stack?.slice(0, 500),
                time: new Date().toISOString()
            }));
        } catch(e) {}
    }

    reload() {
        try {
            // В Telegram reload() может не работать — используем href
            const url = window.location.href;
            window.location.replace(url);
        } catch(e) {
            window.location.href = window.location.href;
        }
    }

    render() {
        if (this.state.hasError) {
            const msg = this.state.error?.message || 'Unknown error';
            const stack = this.state.error?.stack?.slice(0, 300) || '';
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',
                    padding: '20px',
                    textAlign: 'center',
                    background: '#000',
                    color: '#fff'
                }}>
                    <div style={{ fontSize: '40px', marginBottom: '16px' }}>⚠️</div>
                    <div style={{ fontSize: '16px', fontWeight: 600, marginBottom: '8px' }}>Ошибка загрузки</div>
                    <div style={{
                        fontSize: '11px',
                        color: '#f66',
                        marginBottom: '8px',
                        wordBreak: 'break-all',
                        maxWidth: '100%',
                        textAlign: 'left',
                        background: '#111',
                        padding: '8px',
                        borderRadius: '6px'
                    }}>
                        {msg}
                    </div>
                    <div style={{
                        fontSize: '10px',
                        color: '#888',
                        marginBottom: '24px',
                        wordBreak: 'break-all',
                        maxWidth: '100%',
                        textAlign: 'left',
                        background: '#111',
                        padding: '8px',
                        borderRadius: '6px',
                        display: stack ? 'block' : 'none'
                    }}>
                        {stack}
                    </div>
                    <button
                        onClick={() => this.reload()}
                        style={{
                            background: '#fff',
                            color: '#000',
                            border: 'none',
                            borderRadius: '8px',
                            padding: '10px 24px',
                            fontSize: '14px',
                            fontWeight: 600,
                            cursor: 'pointer'
                        }}
                    >
                        Перезагрузить
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
